import React from 'react'
import './style.scss'

const Index = ({ pageContext, location }) => (
  <div className="page-404">
    <div className="background">
      <div className="ground"></div>
    </div>
    <div className="container">
      <div className="left-section">
        <div className="inner-content">
          <h1 className="heading"> 404 </h1>
          <p className="subheading">
            Looks like the page you were looking for is no longer here.
          </p>
        </div>
      </div>
      <div className="right-section"></div>
    </div>
  </div>
)

export default Index
